<section class=" about-page">
	<div class="container">
<iframe width="100%" height="900px" [src]="src"></iframe>
	</div>
</section>